import { render, staticRenderFns } from "./CopyCoupon.vue?vue&type=template&id=2ea66a10"
import script from "./CopyCoupon.vue?vue&type=script&lang=js"
export * from "./CopyCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports